import { orchestrator } from 'satcheljs';
import { createDateRangeFromType } from 'owa-datetime-utils';
import { updateDateRange } from '../store/actions/updateDateRange';
import { updateDateRangeType } from '../store/actions/updateDateRangeType';
import { updateDateRangeTypeInStore } from '../store/mutators/updateDateRangeTypeInStore';
import {
    onAvailableWidthBucketChanged,
    getBrowserWidthBucket,
    LayoutChangeSource,
} from 'owa-layout';

// TODO: VSO #89735 Audit boundary between surface and canvas

orchestrator(updateDateRangeType, actionMessage => {
    let { dateRangeType, store, numDaysInDayRange, forceUpdate } = actionMessage;

    if (store.dateRangeType !== dateRangeType || forceUpdate) {
        updateDateRangeTypeInStore(dateRangeType, store);

        let currentDate = store.selectedDate;
        let newDateRange = createDateRangeFromType(
            dateRangeType,
            currentDate,
            store.userOptions.weekStartDay,
            store.userOptions.workDays,
            numDaysInDayRange
        );

        updateDateRange(newDateRange, store, forceUpdate);
        onAvailableWidthBucketChanged(
            getBrowserWidthBucket(),
            LayoutChangeSource.DateRangeTypeChange
        );
    }
});
